// T22.143 (Kelly video 2026-10-12): an upload outlives the settings pane that
// started it — clicking another block unmounts the pane while the XHR keeps
// running. This module-level registry, keyed by the block the upload belongs
// to (`uploadKey`), lets a remounted pane for the SAME block show that
// upload's progress and Cancel it, instead of an idle dropzone.
import { useSyncExternalStore } from "react";

const uploads = new Map();
const listeners = new Set();

const emit = () => listeners.forEach((listener) => listener());

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// `cancel` doubles as the entry's identity, so a finished upload never
// removes a newer one started for the same key.
export const startActiveUpload = (key, cancel) => {
  uploads.set(key, { percent: 0, cancel });
  emit();
};

export const setActiveUploadPercent = (key, cancel, percent) => {
  const entry = uploads.get(key);
  if (!entry || entry.cancel !== cancel) return;
  uploads.set(key, { ...entry, percent });
  emit();
};

export const endActiveUpload = (key, cancel) => {
  const entry = uploads.get(key);
  if (!entry || entry.cancel !== cancel) return;
  uploads.delete(key);
  emit();
};

export const getActiveUpload = (key) =>
  key == null ? undefined : uploads.get(key);

export const useActiveUpload = (key) =>
  useSyncExternalStore(subscribe, () => getActiveUpload(key));
